module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1C03QXm/tc-custom/9781936535460.jpg?1718282808968",
      "alt": "This image is the cover for the book Son of the Hero, The Varayan Memoir"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Son of the Hero, The Varayan Memoir\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Gil Tyner has plans for the future: he’s going to be a computer programmer in the bustling technology Mecca of Silicon Valley. And as his 21st birthday approaches, he’s on the cusp of realizing his goals."), _c('br'), _c('br'), _vm._v("But fate has other plans. A note from his mother on his birthday propels Gil into The Buffer Zone, seven magical kingdoms that stand between our world and the realm of the immortal elves."), _c('br'), _c('br'), _vm._v("Gil’s about to learn that plans can change. When destiny calls, he’ll discover that the life he’d imagined and the life he’ll lead will be very different.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rick Shelley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rick Shelley (January 1, 1947 - January 27, 2001) was a military science fiction author. In addition to a plethora of short fiction, he also wrote the Dirigent Mercenary Corps, Spec Ops Squad, Federation War, 13 Spaceborn, Seven Towers, and Varayan Memoir series.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    JABberwocky Literary Agency, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0